import React from 'react';

import noop from '@atlaskit/ds-lib/noop';
import { Box } from '@atlaskit/primitives/compiled';
import Radio from '@atlaskit/radio/radio';

export default function RadioDefaultExample(): React.JSX.Element {
	return (
		<Box>
			<Radio
				value="default radio"
				label="Default radio"
				name="radio-default"
				testId="radio-default"
				isChecked={true}
				onChange={noop}
			/>
			<Radio
				value="disabled radio"
				label="Disabled radio"
				name="radio-disabled"
				testId="radio-disabled"
				isChecked={false}
				isDisabled={true}
				onChange={noop}
			/>
		</Box>
	);
}
